exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centeredContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: #101010;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n", ""]);

// exports
